import { useMemo } from 'react';
import { v4 } from 'uuid';


export const useUuid = () => {
    const uuid = useMemo(() => v4(), []);

    return uuid;
};
